const currentUserQuery = require('./currentUser');

module.exports = {
  currentUserQuery,
};
